import type { PhotosAtom } from "@/types/common/photos";
import { atom } from "jotai";

export const photosAtom = atom<PhotosAtom[] | any[]>([]);
//MEMO: 型はとりあえず
photosAtom.debugLabel = "photosAtom";
